var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter"},[_c('div',{staticClass:"counter__details"},[_c('span',{staticClass:"counter__details--number"},[_vm._v(_vm._s(_vm.number))]),_c('span',{staticClass:"counter__details--title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }